import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const CrossBrandMenuItemContainerDefaultBox = styled.li`
    display: block;
`;

export const CrossBrandMenuItemContainerBox = styledByTheme(CrossBrandMenuItemContainerDefaultBox)
    .apply();
